<template>
  <v-dialog v-model="d" width="30%" persistent>
    <v-card>
      <v-card-title>Delete Customer</v-card-title>
      <v-card-text>
        Are you sure you want to delete {{active.name}}?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
        <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="deleteCustomer">Delete Customer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {CustomersHttp} from "@/http/CustomersHttp";

export default {
  name: "DeleteContactModal",
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapState("customers", ["deleteCustomerDialog", "activeCustomer"]),
    d: {
      get() {
        return this.deleteCustomerDialog;
      }
    },
    active: {
      get() {
        return this.activeCustomer;
      }
    }
  },
  methods: {
    ...mapActions("customers", ["setDeleteCustomerDialog", "setActiveCustomer", "setCustomers"]),
    ...mapMutations("app", ["setToast"]),
    async closeDialog() {
      await this.setActiveCustomer({});
      await this.setDeleteCustomerDialog(false);
    },
    async deleteCustomer() {
      try {
        this.isLoading = true;
        await CustomersHttp.deleteCustomer(this.active._id);
        this.setToast({color: 'success', text: 'Customer deleted successfully', show: true});
        await this.setCustomers();
        await this.setActiveCustomer({});
        await this.setDeleteCustomerDialog(false);
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
